// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"de8ca1bc","522":"be2a87b7","888":"687ef46e"}[chunkId] + ".chunk.css";
};